const InfoPage = () => {
  return (
    <div className="h-full w-full bg-white dark:bg-gray-900">
      <iframe
        title="Labwick informatie"
        src="/features.html"
        className="h-full w-full border-0"
      />
    </div>
  );
};

export default InfoPage;
